import { coreDefaultTheme } from '@kite-js/theme';
import { coreJapanicanTheme } from './theme-japanican';
import { ULTheme, ULThemeBuilder } from '@theme/types';

const JapanicanThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreJapanicanTheme,
        logoUrl:
            cultureCode && ['ko-kr', 'zh-cn', 'zh-hk', 'zh-tw'].includes(cultureCode)
                ? `https://cdn6.agoda.net/images/MVC/default/japanican-${cultureCode}.svg`
                : 'https://cdn6.agoda.net/images/MVC/default/japanican-en-us.svg',
        background: {
            image:
                'url(https://cdn6.agoda.net/images/japanican/home/hp-jap-02.png), linear-gradient(rgb(121, 193, 204), rgb(190, 224, 208))',
            position: 'center bottom',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/MVC/default/favicon/japanican/favicon.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    // TODO: this is not good, but I use it for around for MSPA
    // please, unify and remove when we take over MSPA login 💪
    if (appId === 'mspa') {
        theme.background = {
            image: 'url(https://cdn6.agoda.net/images/mobile/JP-mweb-hp02.png)',
            position: '0 0',
            size: '100% 100%',
        };
    }

    return theme;
};

export default JapanicanThemeBuilder;
